import './VisitSiteButton.scss';

export default function VisitSiteButton({ url = 'https://www.jobyaviation.com', align = 'center', shouldAnimate = false }) {
  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer"
      className={`visit-site-button visit-site-button--${align} ${shouldAnimate ? 'visit-site-button--animate-in' : ''}`}
    >
        <span className="visit-site-button__text">Visit Our Website</span>
        <svg className="visit-site-button__icon" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <path d="M0.816667 7.58333L0 6.76667L5.6 1.16667H0.583333V0H7.58333V7H6.41667V1.98333L0.816667 7.58333Z" fill="#F5F4DF"/>
        </svg>
    </a>
  );
}

